export class CandidateActions {
    positiveCandidateStatusActionName: string;
    positiveCandidateStatusId: number;
    negativeCandidateStatusActionName: string;
    negativeCandidateStatusId: number;
}
